import m from 'mithril'
import type { Me, SessionResponse } from '../shared/types.ts'
import { api, setToken } from './api.ts'

export const state = {
  me: null as Me | null,
  providers: [] as string[],
  devAuth: false,
  ready: false,
}

export const loadSession = async () => {
  const [providers, me] = await Promise.all([
    api<{ providers: string[]; dev: boolean }>('/api/auth/providers').catch(() => null),
    api<Me>('/api/auth/me').catch(() => null),
  ])
  state.providers = providers?.providers ?? []
  state.devAuth = providers?.dev ?? false
  state.me = me
  state.ready = true
  m.redraw()
}

export const devLogin = async (username: string) => {
  const session = await api<SessionResponse>('/api/auth/dev', {
    method: 'POST',
    body: { username },
  })
  setToken(session.token)
  state.me = session.user
  m.route.set('/')
}

export const logout = async () => {
  await api('/api/auth/logout', { method: 'POST' }).catch(() => {})
  setToken(null)
  state.me = null
  m.route.set('/')
}
